/**
 * imageService — fetches authenticated images as blobs and returns a
 * bounded object URL. Extracted from AuthenticatedImage so the
 * component no longer imports `apiClient` directly.
 */

import { apiClient } from './apiClient';

/**
 * Fetch a protected image URL and return a blob Object URL that the
 * caller must `URL.revokeObjectURL` when it's done.
 *
 * Throws on network failure; callers show the fallback state.
 */
export async function fetchAuthenticatedImageUrl(src: string): Promise<string> {
    const response = await apiClient.get<Blob>(src, { responseType: 'blob' });
    return URL.createObjectURL(response.data);
}
